var map = {
	"./dashboards/communication/employee-attendance": 968,
	"./dashboards/communication/employee-attendance.json": 968,
	"./dashboards/communication/employee-locations": 969,
	"./dashboards/communication/employee-locations.json": 969,
	"./dashboards/communication/meeting-room-usage": 970,
	"./dashboards/communication/meeting-room-usage.json": 970,
	"./dashboards/communication/people-counts": 971,
	"./dashboards/communication/people-counts.json": 971,
	"./dashboards/dashboard/dashboard": 972,
	"./dashboards/dashboard/dashboard.json": 972,
	"./dashboards/dashboard/redirect-page": 973,
	"./dashboards/dashboard/redirect-page.json": 973,
	"./dashboards/facility_management/air-quality": 974,
	"./dashboards/facility_management/air-quality.json": 974,
	"./dashboards/facility_management/bcp-overview": 975,
	"./dashboards/facility_management/bcp-overview.json": 975,
	"./dashboards/facility_management/device-status-overview": 976,
	"./dashboards/facility_management/device-status-overview.json": 976,
	"./dashboards/facility_management/meeting-room-outlook-usage": 977,
	"./dashboards/facility_management/meeting-room-outlook-usage.json": 977,
	"./dashboards/facility_management/network": 978,
	"./dashboards/facility_management/network.json": 978,
	"./dashboards/facility_management/people-counts-analysis": 979,
	"./dashboards/facility_management/people-counts-analysis.json": 979,
	"./dashboards/labor_management/employee-access-log": 980,
	"./dashboards/labor_management/employee-access-log.json": 980,
	"./dashboards/organization/configs/air-quality-setting": 981,
	"./dashboards/organization/configs/air-quality-setting.json": 981,
	"./dashboards/organization/configs/area-setting": 982,
	"./dashboards/organization/configs/area-setting.json": 982,
	"./dashboards/organization/configs/attendance-rate-setting": 983,
	"./dashboards/organization/configs/attendance-rate-setting.json": 983,
	"./dashboards/organization/configs/audit-write-log": 984,
	"./dashboards/organization/configs/audit-write-log.json": 984,
	"./dashboards/organization/configs/camera-zone-setting": 985,
	"./dashboards/organization/configs/camera-zone-setting.json": 985,
	"./dashboards/organization/configs/device-location-setting": 986,
	"./dashboards/organization/configs/device-location-setting.json": 986,
	"./dashboards/organization/configs/employee-setting": 987,
	"./dashboards/organization/configs/employee-setting.json": 987,
	"./dashboards/organization/configs/employee-terminal-setting": 988,
	"./dashboards/organization/configs/employee-terminal-setting.json": 988,
	"./dashboards/organization/configs/floor-setting": 989,
	"./dashboards/organization/configs/floor-setting.json": 989,
	"./dashboards/organization/configs/location-setting": 990,
	"./dashboards/organization/configs/location-setting.json": 990,
	"./dashboards/organization/configs/meeting-room-analysis-setting": 991,
	"./dashboards/organization/configs/meeting-room-analysis-setting.json": 991,
	"./dashboards/organization/configs/organization-setting": 992,
	"./dashboards/organization/configs/organization-setting.json": 992,
	"./dashboards/organization/configs/people-count-setting": 993,
	"./dashboards/organization/configs/people-count-setting.json": 993,
	"./dashboards/organization/configs/tenant-setting": 994,
	"./dashboards/organization/configs/tenant-setting.json": 994,
	"./dashboards/organization/configs/user-setting": 995,
	"./dashboards/organization/configs/user-setting.json": 995,
	"./dashboards/organization/configs/verkada-device-setting": 996,
	"./dashboards/organization/configs/verkada-device-setting.json": 996,
	"./dashboards/organization/configs/working-hour-setting": 997,
	"./dashboards/organization/configs/working-hour-setting.json": 997,
	"./dashboards/organization/configuration": 998,
	"./dashboards/organization/configuration.json": 998,
	"./dashboards/signage_components/signage-components": 999,
	"./dashboards/signage_components/signage-components.json": 999,
	"./formatter": 1000,
	"./formatter.json": 1000,
	"./global": 530,
	"./global.json": 530,
	"./i18n/ja": 1001,
	"./i18n/ja.json": 1001,
	"./menus/header": 1002,
	"./menus/header.json": 1002,
	"./menus/sidebar": 1003,
	"./menus/sidebar.json": 1003,
	"./style": 1004,
	"./style.json": 1004,
	"./templates": 1005,
	"./templates.json": 1005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2344;